document.documentElement.classList.add('pf-js');
/* Portofino landing page — reveal animations, product gallery, variant price */
(function () {
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.pf-reveal:not(.is-visible)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initProduct(root) {
    (root || document).querySelectorAll('[data-pf-product]').forEach(function (wrap) {
      if (wrap.dataset.pfReady) return;
      wrap.dataset.pfReady = '1';

      var main = wrap.querySelector('[data-pf-main]');
      wrap.querySelectorAll('[data-pf-thumb]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var img = main && main.querySelector('img');
          if (img) {
            img.src = btn.dataset.src;
            img.removeAttribute('srcset');
            img.alt = btn.dataset.alt || '';
          }
          wrap.querySelectorAll('[data-pf-thumb]').forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
        });
      });

      var select = wrap.querySelector('[data-pf-variant]');
      if (!select) return;
      var priceEl = wrap.querySelector('[data-pf-price]');
      var compareEl = wrap.querySelector('[data-pf-compare]');
      var submit = wrap.querySelector('[data-pf-submit]');
      select.addEventListener('change', function () {
        var opt = select.options[select.selectedIndex];
        if (priceEl) priceEl.textContent = opt.dataset.price;
        if (compareEl) {
          compareEl.textContent = opt.dataset.compare || '';
          compareEl.hidden = !opt.dataset.compare;
        }
        if (submit) {
          var available = opt.dataset.available === 'true';
          submit.disabled = !available;
          submit.querySelector('span').textContent = available ? submit.dataset.label : submit.dataset.soldout;
        }
        if (opt.dataset.image && main) {
          var img = main.querySelector('img');
          if (img) { img.src = opt.dataset.image; img.removeAttribute('srcset'); }
        }
      });
    });
  }

  function init(root) { initReveal(root); initProduct(root); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else { init(); }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* ---------- Header, finish selector, slider, sticky bar, video, AJAX cart ---------- */
(function () {
  if (window.__pfExtras) return;
  window.__pfExtras = true;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* Click delegation (works after Theme Editor reloads too) */
  document.addEventListener('click', function (e) {
    var t = e.target;

    /* header search toggle */
    var st = t.closest('[data-pf-search-toggle]');
    if (st) {
      var hd = st.closest('[data-pf-header]');
      var box = hd && hd.querySelector('[data-pf-search]');
      if (box) {
        box.hidden = !box.hidden;
        if (!box.hidden) { var i = box.querySelector('input[type=search]'); if (i) i.focus(); }
      }
      return;
    }

    /* mobile drawer close */
    var cl = t.closest('[data-pf-close]');
    if (cl) { var d = cl.closest('details'); if (d) d.open = false; return; }

    /* finish selector */
    var sw = t.closest('[data-fn]');
    if (sw) {
      var wrap = sw.closest('[data-pf-finish]');
      if (!wrap) return;
      var key = sw.getAttribute('data-fn');
      wrap.querySelectorAll('[data-fn]').forEach(function (b) {
        var on = b === sw; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      wrap.querySelectorAll('[data-fn-img]').forEach(function (el) { el.classList.toggle('is-on', el.getAttribute('data-fn-img') === key); });
      wrap.querySelectorAll('[data-fn-panel]').forEach(function (el) { el.hidden = el.getAttribute('data-fn-panel') !== key; });
      return;
    }

    /* slider arrows */
    var ar = t.closest('[data-ps]');
    if (ar) {
      var sl = ar.closest('[data-pf-slider]');
      var tr = sl && sl.querySelector('[data-ps-track]');
      var card = tr && tr.firstElementChild;
      if (tr && card) tr.scrollBy({ left: (card.offsetWidth + 16) * Number(ar.getAttribute('data-ps')), behavior: 'smooth' });
      return;
    }

    /* video play */
    var pl = t.closest('.sp__play');
    if (pl) {
      var w = pl.closest('[data-sp-video]');
      if (!w) return;
      var tpl = w.querySelector('template[data-sp-template]');
      var src = w.getAttribute('data-video-src');
      var vid;
      if (tpl) { vid = tpl.content.querySelector('video'); vid = vid && vid.cloneNode(true); }
      else if (src) { vid = document.createElement('video'); vid.src = src; vid.controls = true; vid.playsInline = true; }
      if (!vid) return;
      vid.autoplay = true;
      w.querySelectorAll('img, .pf-placeholder, .sp__tag').forEach(function (n) { n.remove(); });
      w.appendChild(vid); pl.remove();
      var p = vid.play && vid.play(); if (p && p.catch) p.catch(function () {});
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-pf-search]').forEach(function (b) { b.hidden = true; });
    document.querySelectorAll('[data-pf-drawer][open]').forEach(function (d) { d.open = false; });
  });

  /* AJAX add to cart for forms marked data-pf-ajax */
  document.addEventListener('submit', function (e) {
    var f = e.target.closest && e.target.closest('form[data-pf-ajax]');
    if (!f || !window.fetch || f.querySelector('input[name="return_to"]')) return; /* return_to = normal submit, goes to cart */
    e.preventDefault();
    var btn = f.querySelector('[type=submit]');
    var original = btn ? btn.innerHTML : '';
    if (btn) btn.disabled = true;
    fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(f) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add'); return j; }); })
      .then(function () { return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); })
      .then(function (cart) {
        document.querySelectorAll('[data-pf-cart-count], .cart-count-bubble span[aria-hidden]').forEach(function (el) { el.textContent = cart.item_count; });
        if (btn) btn.innerHTML = f.getAttribute('data-added') || 'Added ✓';
        document.dispatchEvent(new CustomEvent('pf:cart-updated', { detail: cart }));
      })
      .catch(function (err) { if (btn) btn.textContent = err.message; })
      .then(function () { setTimeout(function () { if (btn) { btn.innerHTML = original; btn.disabled = false; } }, 2200); });
  });

  /* Scroll: header shrink + sticky buy bar */
  var ticking = false;
  function onScroll() {
    ticking = false;
    var y = window.scrollY || window.pageYOffset;
    document.querySelectorAll('[data-pf-header][data-shrink]').forEach(function (h) { h.classList.toggle('is-small', y > 40); });
    document.querySelectorAll('[data-pf-sticky]').forEach(function (bar) {
      var start = 600;
      if (bar.getAttribute('data-trigger') === 'hero') {
        var hero = document.querySelector('.pf-hero');
        if (hero) start = hero.getBoundingClientRect().bottom + y - 200;
      }
      var foot = document.querySelector('.ft, footer');
      var nearEnd = foot && foot.getBoundingClientRect().top < window.innerHeight;
      var on = y > start && !nearEnd;
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
    });
  }
  window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
  document.addEventListener('shopify:section:load', onScroll);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', onScroll); else onScroll();
})();
